module.exports = __webpack_public_path__ + "static/media/feature-8.6a17ced7.jpg";